import { Card } from "@mui/material";
import styled from "styled-components";

interface IOutageCardContainerStyle {
  widthOutageCard?: any;
}

interface IOutageCardStyle {
  fontSizeBase?: string;
  width?: any;
}

export const OutageCardContainerStyle = styled.div<IOutageCardContainerStyle>`
  ${({ widthOutageCard }) => `
    width: ${widthOutageCard};
  `}
`;

export const OutageCardStyle = styled(Card)<IOutageCardStyle>`
  ${({ theme, fontSizeBase = `${theme.uptimeFontSizes.desktop.fz5}px` }) => `
    font-size: ${fontSizeBase};
    height: 9.125em !important;
    cursor: pointer;
    border-radius: 0.625em !important;
    background-color: ${theme.uptimeColors.grayScales.white};
    padding: 0.750em 1em;
    box-sizing: border-box;
    &:hover {
      border-color: transparent;
      box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16),
        0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
    }
    .outage-icon {
      display: flex;
      justify-content: space-between;
      img {
        width: 30px;
      }
      .outage-last-updated{
        font-size: ${theme.uptimeDynamicFontSize?.outageCard?.lastUpdate};
        color: ${theme.uptimeColors.grayScales.darkerGray};
        font-weight: 600;
      }
    }
    .outage-content,
    .outage-title {
      margin-top: ${theme.uptimeSpace[4]}px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    .outage-title {
      font-weight: normal;
      color: ${theme.uptimeColors.textColors.primary};
      font-size:  ${theme.uptimeDynamicFontSize?.outageCard?.title || "1.25em"};
      line-height: ${theme.uptimeDynamicAlignCenter?.newsAndKnowledge?.outage?.lineHeightTitle ?? `${theme.uptimeLineHeights.desktop.lh5}px`};
      -webkit-line-clamp: 1;
    }
    .outage-content {
      color: ${theme.uptimeColors.grayScales.darkerGray};
      font-size: ${theme.uptimeDynamicFontSize?.outageCard?.desc || "0.75em"};
      line-height: ${theme.uptimeDynamicAlignCenter?.newsAndKnowledge?.outage?.lineHeightContent ?? `${theme.uptimeLineHeights.desktop.lh3 + 1}px`};
      -webkit-line-clamp: 2;
    }
    
  `}
`;
